import React from 'react'

import Icon from 'components_new/atoms/Icon'
import IconButton from 'components_new/atoms/IconButton'

import Tooltip from 'components_new/atoms/Tooltip'
import { useTranslation } from 'language/translator'

const HelpButton = () => {
  const { t, lang } = useTranslation()

  const docsUrl =
    lang === 'en' ? 'https://homepal.se/en/docs' : 'https://homepal.se/docs'

  return (
    <Tooltip title={t('guides', 'how_homepal_works')}>
      <IconButton href={docsUrl} newTab size="small">
        <Icon fontSize="small" name="HelpOutlineOutlined" />
      </IconButton>
    </Tooltip>
  )
}

export default HelpButton
